<template>
  <div id="GoTop" @click="GoTop()">
    <span class="el-icon-download"></span>
  </div>
</template>
<script>
export default {
  name: "GoTop",
  data() {
    return {
      flag: false
    };
  },
  methods: {
    GoTop() {
      (function smoothscroll() {
        var currentScroll =
          document.documentElement.scrollTop || document.body.scrollTop;
        if (currentScroll > 0) {
          window.requestAnimationFrame(smoothscroll);
          window.scrollTo(0, currentScroll - currentScroll / 10);
        }
      })();
    }
  }
};
</script>
<style scoped>
#GoTop {
  width: 56px;
  height: 50px;
  position: fixed;
  right: 50px;
  bottom: 140px;
  z-index: 99999999;
  cursor: pointer;
  background: white;
  border-radius: 10px;
  box-shadow: 0 0 3px 1px #ccc;
}
#GoTop > span {
  display: block;
  width: 100%;
  height: 100%;
  /* color: rgb(8, 162, 233); */
  transform: rotate(180deg);
  font-size: 30px;
  padding-top: 10px;
}
#GoTop :hover {
  color: #01afab;
}
.el-icon-download:before {
  margin-left: 13px;
}
</style>



// WEBPACK FOOTER //
// src/components/GoTop.vue